import LenderLogo from './LenderLogo'
import { useRates } from '../hooks/useRates'

/**
 * RateCarousel — a slow scrolling strip of ONLY the lenders the business has
 * curated for it in /dataentry (show_in_carousel). Renders nothing when none are
 * selected, so the broker controls exactly which rates are advertised — the
 * responsible-advertising replacement for the old all-lender ticker.
 */
export default function RateCarousel() {
  const { data } = useRates()
  const rates = data?.carousel ?? []

  if (rates.length === 0) return null

  const loop = [...rates, ...rates]

  return (
    <div className="marquee border-b border-[#E8E8E2] bg-white py-2.5" aria-label="Selected lender rates">
      <div className="marquee-track items-center" style={{ ['--marquee-duration' as string]: `${Math.max(30, rates.length * 5)}s` }}>
        {loop.map((r, i) => (
          <span key={i} className="inline-flex items-center gap-2 mx-6 shrink-0 text-sm whitespace-nowrap">
            <LenderLogo name={r.lender_name} size={20} />
            <span className="text-gs-text-muted">{r.product_name}</span>
            <span className="font-heading font-semibold text-ink tab-num">{(r.rate * 100).toFixed(2)}%</span>
          </span>
        ))}
      </div>
    </div>
  )
}
